<template>
  <div>
    <div class="register-top">
      <h2 class="mb-6">
        {{ $t('register.confirmation.title') }}
        <span style="color: #F07B83;">{{ user.firstname }}</span> !<br />
        {{ $t('register.confirmation.subtitle') }}
      </h2>
      <p>{{ $t('register.confirmation.body') }}</p>
    </div>
    <div class="register-bottom">
      <v-dialog v-model="share" max-width="290">
        <v-card>
          <v-card-title class="headline">{{
            $t('register.confirmation.share')
          }}</v-card-title>
          <v-card-text>
            <ShareNetwork
              network="facebook"
              url="https://remisetitres.fr.ch"
              title="Remise des titres 2020 | Übergabe der Titel 2020"
              style="margin-right: 20px;"
            >
              <v-icon>mdi-facebook</v-icon>
            </ShareNetwork>
            <ShareNetwork
              network="twitter"
              url="https://remisetitres.fr.ch"
              title="Remise des titres 2020 | Übergabe der Titel 2020"
            >
              <v-icon>mdi-twitter</v-icon>
            </ShareNetwork>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="share = false">
              {{ $t('register.confirmation.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <register-base-button
        @click.native="share = true"
        gradient="linear-gradient(90deg, #FF757D 0%, #FF2EB3 100%)"
      >
        {{ $t('register.confirmation.share') }}
      </register-base-button>
      <br />
      <router-link :to="{ name: 'Home' }" class="register-link">
        {{ $t('register.confirmation.back') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import RegisterBaseButton from '@/components/RegisterBaseButton'

export default {
  data() {
    return {
      share: false
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/get']
    }
  },
  components: {
    RegisterBaseButton
  }
}
</script>
